import { Chip, Link, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { t } from 'i18next';
import { BlankCell } from '../../../../common/components/Cells/BlankCell';
import { JavaProvider } from '../../../../common/reports/models/JavaProvider';
import { PAGE_BREAK_AVOID } from '../../constants/constants';

type Props = {
  javaProviders: JavaProvider[];
};

export const JavaProvidersTable = ({ javaProviders }: Props) => {
  return (
    <Paper variant="outlined">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell colSpan={3} sx={{ pb: 0, border: 'none' }}>
              <Typography component="span" variant="h5">
                {t('cryptoLibrarySecurityTitle')}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t('name')}</TableCell>
            <TableCell>{t('version')}</TableCell>
            <TableCell>{t('issues')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {javaProviders.map((j, i) => (
            <TableRow key={i} sx={{ verticalAlign: 'top', ...PAGE_BREAK_AVOID }}>
              <TableCell>{j.getName()}</TableCell>
              <TableCell>{j.getVersion()}</TableCell>
              <TableCell sx={{ pb: 0.5 }}>
                {j.getVulnerabilities().length === 0 && <BlankCell />}
                {j.getVulnerabilities().map((v, index) => (
                  <Chip key={index} component={Link} href={v.getUrl() ?? undefined} label={v.getName()} sx={{ mb: 1, mr: 1 }} />
                ))}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};
